const poaLang = {
  en: {
    approvedPoa: "Approved POA",
  },
  es: {
    approvedPoa: "POA aprobado",
  },
};
export default poaLang;
